import ReviewCarousel from '../../../components/reviewCarousel/ReviewCarousel';
import { ReviewsData } from '../../../dummyData/reviewsData';
import ReviewBg from '../../../assets/home/trvto_reviewBg.png';
import './review.css';
import MobileCarouselCom from '../../../components/mobCarousel/MobileCarousel';

const ReviewSection = () => {
    return (
        <div id='reviewSection' className='reviewSection customContainer'>
            <div className='reviewWrapper'>
                <div className='alignCenter mobCenter'>
                    <div>
                        <p className='pageCount'>Reviews</p>
                        <p className='homeTitle'>What They Say!</p>
                    </div>
                </div>
                <div className='mobHidden'>
                    <ReviewCarousel data={ReviewsData} />
                    <img className='reviewBg' src={ReviewBg} alt='trvto_Review' loading='lazy' decoding='async' />
                </div>
                <div className='mobDisplay'>
                    <MobileCarouselCom type='review' data={ReviewsData} />
                </div>
            </div>
        </div>
    );
};

export default ReviewSection;
